import { orderBy } from "lodash"
import { isPopulatedArray } from "../helpers"
import { NoteCard } from "../widgets"
import { Note } from "../../modules/core/applications"
import clsx from "clsx";
import { KTSVG } from "../../../_metronic/helpers";

export type PropsWithNotes<P extends object = {}> = P & {
  showNotes: boolean;
};

type RowProps = {
  colSpan: number
  notes: Array<Note>
}

export const TableNotesRow = ({colSpan, notes} : RowProps) => {
  
  if (! (colSpan && notes && isPopulatedArray(notes))) {
    return null;
  }

  return(
  <tr>
    <td colSpan={colSpan} className="p-0 align-top">
      <div className="d-flex flex-column items-align-stretch gap-2 p-4">
        <div role="columnheader" className="fs-7 fw-bolder text-muted text-uppercase min-w-70px">NOTES :</div>                    
        {orderBy(notes, ['dteCr'], ['desc']).map( (note, idx) => (
          <NoteCard key={`note${idx}`} note={note} />                            
        ))}
      </div>
    </td>            
  </tr>
  )
}

type CellProps = {
  id: number
  hasNotes: boolean
  show: boolean
  toggleNotes: (id : number) => void
}

export const ToggleNotesCell = ({id, hasNotes, show, toggleNotes}: CellProps) => {    

  if (! (hasNotes)) {
    return null;
  }

  return (    
    <button
      className={clsx(
        'btn btn-sm px-2 ms-n4',
        {'btn-active-light-primary active' : show},
        {'btn-light' : !show},
      )}
      title="Show Notes"
      onClick={(e: any) => toggleNotes(id)}
    >
      <KTSVG path='/media/icons/duotune/communication/com007.svg' className='svg-icon-2 m-0' />
    </button>            
  )
}


type HeaderProps = {
  hasNotes: boolean
  show: boolean
  toggleNotes: () => void
}

export const ToggleNotesHeaderCell = ({hasNotes, show, toggleNotes} : HeaderProps) => {    

  if (! hasNotes) {
    return null;
  }

  return (    
    <button
      className={clsx(
        'btn btn-sm px-2 ms-n4',
        {'btn-active-light-primary active' : show},
        {'btn-light' : !show},
      )}
      title={show ? "Hide All Notes" : "Show All Notes"}
      onClick={(e: any) => toggleNotes()}
    >
      <KTSVG path='/media/icons/duotune/communication/com007.svg' className='svg-icon-2 m-0' />
    </button>            
  )
}
